// extracted by mini-css-extract-plugin
module.exports = {"shareModal":"styles_shareModal__2xVhk","shareContainer":"styles_shareContainer__gir8g","shareArt":"styles_shareArt__IUSEr","sendContainer":"styles_sendContainer__2TPfK"};